(function ( $ ) {

	$.fn.clicktofocus = function () {
		var elem = $( this ),
			target = elem.data('to-focus');

		var init = function () {
			elem.on( 'click', function () {
				$(target).focus();
			});
		};

		init();
		return this;
	};

}( jQuery ));
